import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import ReviewUserComponent from './components/UserReviewsComponent';

type TUserReviewsAppProps = {
  appState?: any;
  environment: any;
};

const ReviewUserApp = ({ /*appState,*/ environment }: TUserReviewsAppProps) => (
  <EnvironmentProvider value={environment}>
    <ReviewUserComponent />
  </EnvironmentProvider>
);

export default ReviewUserApp;
